<template>
  <el-dialog :visible.sync="weixinUrlVisible" title="微信端配置" custom-class="dialogPaddingTop0">
    <el-container>
      <table>
        <tr>
          <td width="100px">菜单名称</td>
          <td>跳转链接</td>
        </tr>
        <tr v-for="(value, key, index) in weixinUrlResult" :key="index">
          <td>{{key}}</td>
          <td>{{value}}</td>
          
        </tr>
      </table>
    </el-container>
    <div class=" dialog-footer"  slot="footer">
    </div>
  </el-dialog>
</template>

<script>
export default {
  created() {
  },
  props:["visible","weixinUrlResult"],
  computed: {
    weixinUrlVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  data() {
    return {
      weixinUrl:[],
    }
  },
  methods: {
    
  }
};
</script>

<style>

</style>